import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { ResponseModel } from '../models/api.model';

import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';


@Injectable()
export class LocationService extends BaseService {

  constructor(private http: HttpClient, private router: Router, messageService: MessageService) {
    super(messageService);

  }

  search(query: string) {
    const sanitizedQuery = this.sanitizationService.sanitizeText(query);
    const encodedQuery = encodeURIComponent(sanitizedQuery);
    return this.http.get(`${environment.baseUrl}api/location/search?query=${encodedQuery}`)
      .pipe(map(res => {
        if (res != null)
          return <ResponseModel<any>>res;
      }));
  }

  locationExists(name: string, city: string, zip: number, locationId?: number) {
    const sanitizedName = this.sanitizationService.sanitizeText(name);
    const sanitizedCity = this.sanitizationService.sanitizeText(city);
    const encodedName = encodeURIComponent(sanitizedName);
    const encodedCity = encodeURIComponent(sanitizedCity);
    const encodedZip = encodeURIComponent(zip);
    let locationExistsURL = `${environment.baseUrl}api/location/locationExists?name=${encodedName}&city=${encodedCity}&zip=${encodedZip}`;
    if (locationId) {
      locationExistsURL += `&locationId=${locationId}`;
    }
    return this.http.get(locationExistsURL)
      .pipe(map(res => {
        if (res != null)
          return <ResponseModel<any>>res;
      }));
  }

}
